import { cn } from "@/lib/cn";
import {
  OUTCOMES_BY_SUBTYPE,
  OUTCOME_LABEL,
  OUTCOME_NOTE_REQUIRED,
  type TaskOutcome,
  type TaskSubtype,
} from "@/api/client360Tasks";

/**
 * 3A subtype-aware outcome chips. Options depend on subtype (§2.3). Used by the
 * quick call-log and the task completion (outcome-required) drawers.
 */
export function OutcomePicker({
  subtype,
  value,
  onChange,
}: {
  subtype: TaskSubtype;
  value: TaskOutcome | "";
  onChange: (o: TaskOutcome) => void;
}) {
  const options = OUTCOMES_BY_SUBTYPE[subtype] ?? OUTCOMES_BY_SUBTYPE.generic;
  return (
    <div className="flex flex-wrap gap-1.5">
      {options.map((o) => (
        <button
          key={o}
          type="button"
          onClick={() => onChange(o)}
          aria-pressed={value === o}
          className={cn(
            "rounded-md border px-2.5 py-1.5 text-xs font-medium transition-colors",
            value === o
              ? "border-primary bg-primary/10 text-primary"
              : "border-border text-muted-foreground hover:text-foreground",
          )}
        >
          {OUTCOME_LABEL[o]}
        </button>
      ))}
    </div>
  );
}

export function noteRequired(outcome: TaskOutcome | ""): boolean {
  return outcome !== "" && OUTCOME_NOTE_REQUIRED.includes(outcome);
}
